import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getAppointmentsForDepositTransfer } from '../../services/appointments';

interface Params {
  customerId: string;
  enabled?: boolean;
}

function useGetDepositTransferAppointmets({
  customerId,
  enabled = true,
}: Params) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useQuery({
    queryKey: [
      'deposit-transfer-appointments',
      businessId,
      customerId,
      user?.userId,
    ],
    queryFn: () =>
      getAppointmentsForDepositTransfer({
        businessId: businessId!,
        customerId,
      }),
    enabled: !!businessId && !!customerId && !!user?.userId && enabled,
  });
}

export default useGetDepositTransferAppointmets;
